<main *ngIf="!data.field_hide_sidebar">
  <div class="container" id="main-container">
    <div class="row">
      <div class="col px-lg-4">
        <app-breadcrumbs [path]="data?.path?.alias" [title]="data?.title"></app-breadcrumbs>
      </div>
    </div>
    <div class="row" *ngIf="data.moderation_state == 'archived'">
      <div class="col px-lg-4">
        <div class="callout danger">
          <div class="callout-inner">
            <div class="callout-title">
              <svg class="icon">
                <use href="/bootstrap-italia/dist/svg/sprites.svg#it-info-circle"></use>
              </svg>
              <span class="visually-hidden">Note</span>
              <span class="text">Contenuto archiviato</span>
            </div>
            <p><span class="node__archived_text">Contenuto archiviato per fini storici di documentazione.</span></p>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-8 px-lg-4 py-lg-2">
        <h1 data-audio="">
          {{ data.title }}
        </h1>
        <h2 class="visually-hidden">Dettagli della notizia</h2>
        <p data-audio="">
          {{ data.information_desc }}
        </p>
      </div>

      <div class="col-lg-3 offset-lg-1">
        <app-social-share [url]="data?.path?.alias"></app-social-share>
        <app-actions-list [mailObject]="data?.title" [path]="data?.path?.alias"></app-actions-list>
        <div class="mt-4 mb-4" *ngIf="data?.field_tags?.length > 0">
          <div class="row">
            <span class="mb-2 small">Argomenti</span>
          </div>
          <ul class="d-flex flex-wrap gap-1">
            <li *ngFor="let tag of data?.field_tags">
              <a class="chip chip-simple" [href]="tag?.path?.alias">
                <span class="chip-label">{{ tag.title }}</span>
              </a>
            </li>
          </ul>
        </div>
        <div class="mt-4 mb-4" *ngIf="data?.field_objectives?.length > 0">
          <div class="row">
            <span class="mb-2 small"><i>Questo contenuto contribuisce agli obiettivi di sviluppo
                sostenibile:</i></span>
          </div>
          <ul class="d-flex flex-wrap gap-1">
            <li *ngFor="let objective of data?.field_objectives">
              <img [src]="objective?.field_icona?.uri?.url" [title]="objective?.name" [alt]="objective?.name"
                class="icon icon-lg" />
            </li>
          </ul>
        </div>

      </div>
    </div>
  </div>
  <div class="container-fluid my-3" *ngIf="data.field_internal_image?.field_media_image">
    <div class="row">
      <figure class="figure px-0 img-full">
        <img [src]="data.field_internal_image?.field_media_image?.uri?.url" class="figure-img img-fluid"
          [alt]="data.field_internal_image?.field_media_image?.meta?.alt" />
        <figcaption class="figure-caption text-center pt-3">
          {{ data.field_internal_image?.field_media_image?.meta?.title }} <span
            *ngIf="data?.field_internal_image?.field_media_licence"> -
            {{data.field_internal_image?.field_media_licence}}</span>
        </figcaption>
      </figure>
    </div>
  </div>
  <div class="container">
    <div class="row border-top border-light row-column-border row-column-menu-left">
      <aside class="col-lg-3">
        <div class="cmp-navscroll sticky-top" aria-labelledby="accordion-title-one">
          <nav class="navbar it-navscroll-wrapper navbar-expand-lg" aria-label="INDICE DELLA PAGINA"
            data-bs-navscroll="">
            <div class="navbar-custom" id="navbarNavProgress">
              <div class="menu-wrapper">
                <div class="link-list-wrapper">
                  <div class="accordion">
                    <div class="accordion-item">
                      <span class="accordion-header" id="accordion-title-one">
                        <button class="accordion-button pb-10 px-3" type="button" data-bs-toggle="collapse"
                          data-bs-target="#collapse-one" aria-expanded="true" aria-controls="collapse-one">
                          INDICE DELLA PAGINA
                          <svg class="icon icon-xs right">
                            <use href="bootstrap-italia/dist/svg/sprites.svg#it-expand"></use>
                          </svg>
                        </button>
                      </span>
                      <div class="progress">
                        <div class="progress-bar it-navscroll-progressbar" role="progressbar" aria-valuenow="0"
                          aria-valuemin="0" aria-valuemax="100" style="width: 0%"></div>
                      </div>
                      <div id="collapse-one" class="accordion-collapse collapse show" role="region"
                        aria-labelledby="accordion-title-one">
                        <div class="accordion-body">
                          <ul class="link-list" data-element="page-index">
                            <li class="nav-item" *ngIf="data.information_body?.value">
                              <a class="nav-link active" href="javascript:void(0);" data-focus-mouse="false"
                                (click)="scrollTo('descrizione')">
                                <span class="title-medium">Descrizione</span>
                              </a>
                            </li>
                            <ng-container *ngFor="let link of links">
                              <li class="nav-item">
                                <a class="nav-link" href="javascript:void(0);" data-focus-mouse="false"
                                  (click)="scrollTo(link.url)">
                                  <span class="title-medium">{{
                                    link.title
                                    }}</span>
                                </a>
                              </li>
                            </ng-container>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </nav>
        </div>
      </aside>
      <section class="col-lg-9 it-page-sections-container border-light">
        <article id="descrizione" class="it-page-section anchor-offset richtext-wrapper"
          *ngIf="data.information_body && data.information_body.value">
          <h2 class="mb-3">Descrizione</h2>
          <p [innerHTML]="data?.information_body?.value"></p>
        </article>
      </section>
    </div>
  </div>
</main>

<main *ngIf="data.field_hide_sidebar">
  <div class="container" id="main-container">
    <div class="row">
      <div class="col px-lg-4">
        <app-breadcrumbs [path]="data?.path?.alias" [title]="data?.title"></app-breadcrumbs>
      </div>
    </div>
    <div class="row" *ngIf="data.moderation_state == 'archived'">
      <div class="col px-lg-4">
        <div class="callout danger">
          <div class="callout-inner">
            <div class="callout-title">
              <svg class="icon">
                <use href="/bootstrap-italia/dist/svg/sprites.svg#it-info-circle"></use>
              </svg>
              <span class="visually-hidden">Note</span>
              <span class="text">Contenuto archiviato</span>
            </div>
            <p><span class="node__archived_text">Contenuto archiviato per fini storici di documentazione.</span></p>
          </div>
        </div>
      </div>
    </div>
    <div class="row row-shadow">
      <div class="col-lg-12 px-lg-4 py-lg-2">
        <h1 data-audio="">
          {{ data.title }}
        </h1>
        <h2 class="visually-hidden">Dettagli della notizia</h2>
        <p data-audio="">
          {{ data.information_desc }}
        </p>
        <div class="hero-text" *ngIf="data.information_body">
          <p [innerHTML]="data?.information_body?.value"></p>
        </div>
      </div>
    </div>
    <div class="container">


      <section class="it-page-sections-container border-light">


      </section>

    </div>
  </div>

</main>